import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";

import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import CardHeader from "@mui/material/CardHeader";
import { makeStyles } from "@mui/styles";
import {
  Card,
  CardContent,
  Switch,
  Grid,
  TextField,
  Typography,

  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Box,
  OutlinedInput,
  Paper,
} from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';

import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

import {
  LocalizationProvider,
  DatePicker,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";


import { useHistory } from "react-router-dom";
import clsx from "clsx";

import moment from "moment";


import { useSelector, useDispatch } from 'react-redux';
import API from "util/API";

import { showSuccessSnackbar, showErrorSnackbar } from 'store/actions/snackbarMessage'
import { nanoid } from 'nanoid'
import {
  getSurchargeSettingsList,
  isOvernightSurcharge,
  getSurchargeHoursError,
  buildWeekdayHours,
  timeStringToDate,
  dateToTimeString,
  formatTime12,
} from "../SurchargeList/surchargeUtils";
import { usePublicHolidays } from 'hooks/usePublicHolidays';



import { noWheelInputProps } from "util/utils";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  submitButton: {
    width: 200,
  },
  sectionPaper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  subsectionTitle: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    fontWeight: 500,
  },
  orderTypesBox: {
    marginTop: theme.spacing(1),
  },
}));


const HolidaySurchargeSettings = (props) => {
  const { surchargeSetting } = props;
  const CHARACTER_LIMIT = 50;
  const classes = useStyles();

  const ORDER_TYPES = ['dinein', 'delivery', 'takeaway', 'pickup'];
  const WEEKDAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  const initialState = {
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: true,
    Sunday: true,
    isEnabled: false,
    isPercentage: true,
    isTax: false,
    isExclusive: false,
    isTaxBasedOnSubtotal: false,
    holidayDate: new Date(),
    amount: 0,
    name: "",
    surchargeDescription: "",
    orderTypes: [],
    weekdayHours: {},
    id: nanoid(),
  };

  const history = useHistory();
  const dispatch = useDispatch();


  const [publicHolidayDays, setPublicHolidayDays] = useState([]);
  const [uiLoading, setUiLoading] = useState(false);
  const showError = (msg) => dispatch(showErrorSnackbar(msg));
  const showSuccess = (msg) => dispatch(showSuccessSnackbar(msg));
  
  // React Query hook for fetching public holidays
  const { mutate: fetchPublicHolidays, isPending: isLoadingHolidays } = usePublicHolidays();

  const [values, setValues] = useState(initialState);
  const restaurant = useSelector(
    (state) => state.restaurant.selectedRestaurant
  );
  const user = useSelector((state) => state.account.user);
  const surchargeId = props.match.params.surchargeId;

  

  const checkWeekdayIsChecked = (surcharge, weekday) => {
    return surcharge.weekdays && surcharge.weekdays.includes(weekday);
  };

  const loadValues = (surcharge) => {
    // Convert lowercase order types from backend to capitalized for UI display
    const orderTypesForUI = (surcharge.orderTypes || []).map(type => {
      // Capitalize first letter of each type
      return type.charAt(0).toUpperCase() + type.slice(1);
    });

    const prevousValues = {
      Monday: checkWeekdayIsChecked(surcharge, 'Monday'),
      Tuesday: checkWeekdayIsChecked(surcharge, 'Tuesday'),
      Wednesday: checkWeekdayIsChecked(surcharge, 'Wednesday'),
      Thursday: checkWeekdayIsChecked(surcharge, 'Thursday'),
      Friday: checkWeekdayIsChecked(surcharge, 'Friday'),
      Saturday: checkWeekdayIsChecked(surcharge, 'Saturday'),
      Sunday: checkWeekdayIsChecked(surcharge, 'Sunday'),
      isEnabled: surcharge.isEnabled,
      isTax: surcharge.isTax,
      isExclusive: surcharge.isExclusive,
      isTaxBasedOnSubtotal: surcharge.isTaxBasedOnSubtotal,
      isPercentage: surcharge.isPercentage,
      holidayDate: new Date(),
      amount: surcharge.amount,
      name: surcharge.name,
      surchargeDescription: surcharge.surchargeDescription ? surcharge.surchargeDescription : "",
      orderTypes: orderTypesForUI,
      weekdayHours: surcharge.weekdayHours || {},
      id: surcharge.id,
    };
    setValues(prevousValues);
  };


  useEffect(() => {
    
    if (!surchargeId) {
      return;
    }
    const existingSurchargeSettings = getSurchargeSettingsList(restaurant);
    const surchargeSetting = existingSurchargeSettings.find(
      (s) => s.id === surchargeId
    );

    if (surchargeSetting) {
      loadValues(surchargeSetting);
      setPublicHolidayDays(surchargeSetting.publicHolidayDays || []);
    }
  }, [surchargeId, restaurant]);



  const handleInputChange = (e) => {
    e.preventDefault();
    const { name, value, type } = e.target;
    // console.log("name", name, value, type);
    if (type === "checkbox") {
      setValues({ ...values, [name]: !values[name] });
    } else {
      setValues({ ...values, [name]: value });
    }
  };

  const updateSurchargeSettings = async () => {
    if (!restaurant) {
      showError('Please go back to the restaurant screen and try again.');
      return;
    }


    setUiLoading(true);
    try {
      await API.put("/updateRestaurantValues/", {
        surchargeSettings: preparePayload(),
      })

      setUiLoading(false);
      showSuccess('Updated successfully');
      history.push("/myRestaurant");
      // if (user.role === "restaurantAdmin") {
      //   history.push("/myRestaurant");
      // } else {
      //   history.push("/restaurants");
      // }

    } catch (error) {
      if (error.response && error.response.status === 403) {
        props.history.push("/sign-in");
      }
      // console.log(JSON.stringify(error));
      setUiLoading(false);

    }
  };

  const handleDateChange = (date) => {
    // console.log("date", date);

    setValues({ ...values, holidayDate: date });
  };

  const addNewHoliday = () => {
    const newItem = moment(values.holidayDate).format("DD/MM/YYYY");
    let updateItems = [...publicHolidayDays];
    if (updateItems.findIndex((item) => item === newItem) > -1) {
      return;
    }

    updateItems.push(newItem);

    setPublicHolidayDays(updateItems);

    //console.log("publicHolidayDays", publicHolidayDays);
  };

  const loadPublicHolidays = () => {
    fetchPublicHolidays(undefined, {
      onSuccess: (holidayDates) => {
        // Merge with existing holidays and remove duplicates
        const updatedHolidays = [...(publicHolidayDays || [])];
        holidayDates.forEach(date => {
          if (!updatedHolidays.includes(date)) {
            updatedHolidays.push(date);
          }
        });
        
        setPublicHolidayDays(updatedHolidays);
        showSuccess(`Loaded ${holidayDates.length} public holidays`);
      },
      onError: (error) => {
        console.error("Error loading public holidays:", error);
        showError(error.message || "Failed to load public holidays");
      }
    });
  };


  const removeItemWithSlice = (items, index) => {
    let newSelectedOptions = [];

    if (index === 0) {
      newSelectedOptions = newSelectedOptions.concat(items.slice(1));
    } else if (index === items.length - 1) {
      newSelectedOptions = newSelectedOptions.concat(items.slice(0, -1));
    } else if (index > 0) {
      newSelectedOptions = newSelectedOptions.concat(
        items.slice(0, index),
        items.slice(index + 1)
      );
    }
    return newSelectedOptions;
  };
  const preparePayload = () => {

    let weekdays = [];
    if (values.Monday) weekdays.push("Monday");
    if (values.Tuesday) weekdays.push("Tuesday");
    if (values.Wednesday) weekdays.push("Wednesday");
    if (values.Thursday) weekdays.push("Thursday");
    if (values.Friday) weekdays.push("Friday");
    if (values.Saturday) weekdays.push("Saturday");
    if (values.Sunday) weekdays.push("Sunday");

    // Convert order types to lowercase for backend storage
    const orderTypesLowercase = (values.orderTypes || []).map(type => type.toLowerCase());

    const payload = {
      publicHolidayDays,
      weekdays,
      isEnabled: values.isEnabled,
      isPercentage: values.isPercentage,
      isTax: values.isTax,
      isExclusive: values.isExclusive,
      isTaxBasedOnSubtotal: values.isTaxBasedOnSubtotal,
      amount: Number(values.amount),
      name: values.name,
      description: values.description,
      orderTypes: orderTypesLowercase,
      ...buildWeekdayHours(weekdays, values.weekdayHours),
      id: values.id,
    };
    const existingSurchargeSettings = getSurchargeSettingsList(restaurant);
    const idx = existingSurchargeSettings.findIndex(
      (item) => item.id === payload.id
    );
    if (idx > -1) {
      existingSurchargeSettings[idx] = payload;
    } else {
      existingSurchargeSettings.push(payload);
    }
    return existingSurchargeSettings;
  };

  
  const deleteDateItem = (date) => {
    const idx = publicHolidayDays.findIndex((item) => item === date);
    // console.log("idx", idx, publicHolidayDays, date);
    if (idx === -1) {
      return;
    }
    setPublicHolidayDays(removeItemWithSlice(publicHolidayDays, idx));
  };

  const handleSwitchChange = (event) => {
    const name = event.target.name;
    const value = event.target.checked;
    if (name === 'isEnabled') {
      setValues({ ...values, isEnabled: value });
      return;
    }

    if (name === 'isPercentage') {
      setValues({ ...values, isPercentage: value });
      return;
    }

    if (name === 'isTax') {
      setValues({ ...values, isTax: value });
      return;
    }

    if (name === 'isExclusive') {
      setValues({ ...values, isExclusive: value });
      return;
    }

    if (name === 'isTaxBasedOnSubtotal') {
      setValues({ ...values, isTaxBasedOnSubtotal: value });
      return;
    }
  };

  const handleOrderTypesChange = (event) => {
    const {
      target: { value },
    } = event;
    setValues({
      ...values,
      orderTypes: typeof value === 'string' ? value.split(',') : value,
    });
  };

  const toggleDayHours = (day) => {
    const weekdayHours = { ...values.weekdayHours };
    if (weekdayHours[day]) {
      delete weekdayHours[day];
    } else {
      weekdayHours[day] = { startTime: "", endTime: "" };
    }
    setValues({ ...values, weekdayHours });
  };

  const setDayTime = (day, field, date) => {
    setValues({
      ...values,
      weekdayHours: {
        ...values.weekdayHours,
        [day]: { ...values.weekdayHours[day], [field]: dateToTimeString(date) },
      },
    });
  };

  const hasHoursError = WEEKDAYS.some(
    (day) => values[day] && getSurchargeHoursError(values.weekdayHours[day])
  );

  return (
    <div>
      {(uiLoading || isLoadingHolidays) ? <LinearProgress /> : null}
      <Card className={clsx(classes.root, classes)}>
        <CardHeader
          title="Surcharge Settings"
          subheader="Configure surcharge rules and conditions"
        />
        <CardContent>
          <Grid container spacing={3}>

            {/* Basic Information Section */}
            <Grid item xs={12}>
              <Paper className={classes.sectionPaper} elevation={2}>
                <Typography variant="h6" className={classes.sectionTitle}>
                  Basic Information
                </Typography>
                <Grid container spacing={2}>
                  <Grid item md={8} xs={12}>
                    <TextField
                      fullWidth
                      label="Surcharge Name"
                      name="name"
                      variant="outlined"
                      value={values.name}
                      onChange={e => setValues({ ...values, name: e.target.value })}
                      required
                    />
                  </Grid>
                  <Grid item md={4} xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={values.isEnabled}
                          onChange={handleSwitchChange}
                          name="isEnabled"
                          color="primary"
                        />
                      }
                      label="Enable Surcharge"
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* Applicable Days Section */}
            <Grid item xs={12}>
              <Paper className={classes.sectionPaper} elevation={2}>
                <Typography variant="h6" className={classes.sectionTitle}>
                  Applicable Days
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  Select the weekdays when this surcharge applies. A day applies all day unless you set specific hours; an end time earlier than the start time ends the next day (e.g. Sunday 5:00 PM – 2:00 AM covers early Monday).
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  {WEEKDAYS.map((day) => {
                    const hours = values.weekdayHours[day];
                    const showHours = values[day] && hours;
                    const error = showHours ? getSurchargeHoursError(hours) : null;
                    const showError = Boolean(error && hours.startTime && hours.endTime);
                    return (
                      <Grid container spacing={2} alignItems="center" key={day}>
                        <Grid item md={2} xs={6}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values[day]}
                                onChange={handleInputChange}
                                name={day}
                                color="primary"
                              />
                            }
                            label={day}
                          />
                        </Grid>
                        <Grid item md={2} xs={6}>
                          {values[day] ? (
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={Boolean(hours)}
                                  onChange={() => toggleDayHours(day)}
                                  color="primary"
                                  inputProps={{ "aria-label": `${day} specific hours` }}
                                />
                              }
                              label={hours ? "Specific hours" : "All day"}
                            />
                          ) : null}
                        </Grid>
                        {showHours ? (
                          <>
                            <Grid item md={4} xs={12}>
                              <TimePicker
                                label="Start time"
                                value={timeStringToDate(hours.startTime)}
                                onChange={(date) => setDayTime(day, "startTime", date)}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    sx: { minWidth: 0 },
                                    helperText: " ",
                                    inputProps: { "aria-label": `${day} start time` },
                                  },
                                }}
                              />
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <TimePicker
                                label="End time"
                                value={timeStringToDate(hours.endTime)}
                                onChange={(date) => setDayTime(day, "endTime", date)}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    sx: { minWidth: 0 },
                                    error: showError,
                                    helperText: showError
                                      ? error
                                      : isOvernightSurcharge(hours)
                                        ? `Ends at ${formatTime12(hours.endTime)} the next day`
                                        : " ",
                                    inputProps: { "aria-label": `${day} end time` },
                                  },
                                }}
                              />
                            </Grid>
                          </>
                        ) : null}
                      </Grid>
                    );
                  })}
                </LocalizationProvider>
              </Paper>
            </Grid>

            {/* Order Types Section */}
            <Grid item xs={12}>
              <Paper className={classes.sectionPaper} elevation={2}>
                <Typography variant="h6" className={classes.sectionTitle}>
                  Order Types
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  Select which order types this surcharge applies to. Leave empty to apply to all types.
                </Typography>
                <Box className={classes.orderTypesBox}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="order-types-label">Select Order Types</InputLabel>
                    <Select
                      labelId="order-types-label"
                      id="order-types-select"
                      multiple
                      value={values.orderTypes}
                      onChange={handleOrderTypesChange}
                      input={<OutlinedInput label="Select Order Types" />}
                      renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {selected.length === 0 ? (
                            <Typography variant="body2" color="textSecondary">All order types</Typography>
                          ) : (
                            selected.map((value) => (
                              <Chip key={value} label={value} color="primary" />
                            ))
                          )}
                        </Box>
                      )}
                    >
                      {ORDER_TYPES.map((type) => {
                        // Capitalize first letter for display
                        const displayType = type.charAt(0).toUpperCase() + type.slice(1);
                        return (
                          <MenuItem key={type} value={displayType}>
                            <Checkbox checked={values.orderTypes.indexOf(displayType) > -1} />
                            {displayType}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Box>
              </Paper>
            </Grid>

            {/* Surcharge Amount Section */}
            <Grid item xs={12}>
              <Paper className={classes.sectionPaper} elevation={2}>
                <Typography variant="h6" className={classes.sectionTitle}>
                  Surcharge Amount
                </Typography>
                <Grid container spacing={3}>
                  <Grid item md={4} xs={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={values.isPercentage}
                          onChange={handleSwitchChange}
                          name="isPercentage"
                          color="primary"
                        />
                      }
                      label="Percentage Based"
                    />
                  </Grid>
                  <Grid item md={8} xs={12}>
                    <TextField
                      fullWidth
                      label={values.isPercentage ? 'Percentage (%)' : 'Amount ($)'}
                      type="number"
                      name="amount"
                      variant="outlined"
                      value={values.amount}
                      onChange={e => setValues({ ...values, amount: Number(e.target.value) })}
                      required
                      inputProps={{ ...noWheelInputProps, min: 0, step: values.isPercentage ? 0.01 : 0.1 }}
                      helperText={values.isPercentage ? 'Enter percentage value (e.g., 10 for 10%)' : 'Enter fixed dollar amount'}
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* Advanced Options Section */}
            <Grid item xs={12}>
              <Paper className={classes.sectionPaper} elevation={2}>
                <Typography variant="h6" className={classes.sectionTitle}>
                  Advanced Options
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={values.isTax}
                          onChange={handleSwitchChange}
                          name="isTax"
                          color="primary"
                        />
                      }
                      label="Is Tax"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={values.isTaxBasedOnSubtotal}
                          onChange={handleSwitchChange}
                          name="isTaxBasedOnSubtotal"
                          color="primary"
                        />
                      }
                      label="Calculate tax on subtotal (before other charges)"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={values.isExclusive}
                          onChange={handleSwitchChange}
                          name="isExclusive"
                          color="primary"
                        />
                      }
                      label="Exclusive (cannot be combined with other surcharges)"
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* Public Holidays Section */}
            <Grid item xs={12}>
              <Paper className={classes.sectionPaper} elevation={2}>
                <Typography variant="h6" className={classes.sectionTitle}>
                  Public Holidays
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  Add specific dates when this surcharge should apply
                </Typography>
                <Box sx={{ mt: 2 }}>
                  <Typography variant="subtitle2" gutterBottom>
                    Selected Holidays ({publicHolidayDays?.length || 0})
                  </Typography>
                  {publicHolidayDays && publicHolidayDays.length > 0 ? (
                    <List dense>
                      {publicHolidayDays.map(item => (
                        <ListItem key={item}>
                          <ListItemAvatar>
                            <EventAvailableIcon color="primary" />
                          </ListItemAvatar>
                          <ListItemText primary={item} />
                          <IconButton 
                            edge="end" 
                            aria-label="delete" 
                            onClick={() => deleteDateItem(item)}
                            size="small"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic', py: 2 }}>
                      No holidays added yet. Click "Load Public Holidays" to import holidays from the API, or add them manually using the date picker.
                    </Typography>
                  )}
                </Box>

                <Grid container spacing={2} sx={{ mt: 2 }} alignItems="center">
                  <Grid item xs={12} md={4}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="Choose a holiday"
                        value={values.holidayDate}
                        onChange={handleDateChange}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            variant: "outlined"
                          }
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={addNewHoliday}
                      fullWidth
                      sx={{ height: 56 }}
                    >
                      Add Holiday
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={loadPublicHolidays}
                      fullWidth
                      sx={{ height: 56 }}
                      disabled={uiLoading || isLoadingHolidays}
                    >
                      Load Public Holidays
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* Description Section */}
            <Grid item xs={12}>
              <Paper className={classes.sectionPaper} elevation={2}>
                <Typography variant="h6" className={classes.sectionTitle}>
                  Description (Optional)
                </Typography>
                <TextField
                  id="descriptions"
                  label="Surcharge Description"
                  multiline
                  rows={3}
                  fullWidth
                  inputProps={{
                    maxLength: CHARACTER_LIMIT,
                  }}
                  value={values.surchargeDescription}
                  variant="outlined"
                  helperText={`${values.surchargeDescription.length}/${CHARACTER_LIMIT} characters`}
                  placeholder="Add a description for this surcharge (optional)"
                  onChange={(e) => setValues({ ...values, surchargeDescription: e.target.value })}
                />
              </Paper>
            </Grid>
          </Grid>

          {/* Save Button */}
          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button
              variant="outlined"
              size="large"
              onClick={() => history.push("/myRestaurant")}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              size="large"
              disabled={uiLoading || !values.name || !values.amount || hasHoursError}
              onClick={updateSurchargeSettings}
              color="primary"
              sx={{ minWidth: 200 }}
            >
              Save Surcharge
            </Button>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
};

export default HolidaySurchargeSettings;
